const { dataFormParse } = require('../utils/dataFormParse');
const { axiosDefault, handleErrors } = require('../utils/defaults');
const moment = require('moment');

const pressRoomService = {
  admin: {
    get: async (id) => {
      try {
        const axios = axiosDefault();
        const { data } = await axios.get(`/api/pressroom/gestao/${id ? id : ''}`);
        return data;
      } catch (error) {
        return handleErrors(error);
      }
    },

    getList: async () => {
      try {
        const axios = axiosDefault();
        const { data } = await axios.get(`/api/pressroom/gestao`);
        return data;
      } catch (error) {
        return handleErrors(error);
      }
    },

    save: async (pressroom) => {
      try {
        const axios = axiosDefault('file');
        const formData = new FormData();

        formData.append('title', pressroom.title);
        formData.append('postingDate', moment(pressroom.postingDate).utc().format('YYYY-MM-DD'));
        formData.append('url', pressroom.url);
        formData.append('type', pressroom.type);
        formData.append('isActive', pressroom.isActive);

        if (pressroom.files_document?.[0]) {
          formData.append('pressroom', pressroom.files_document[0]); 
        }

        const { data } = await axios.post(`/api/pressroom/gestao`, formData);
        return data;
      } catch (error) {
        return handleErrors(error);
      }
    },

    edit: async (pressroom) => {
      try {
        const axios = axiosDefault('file');
        const formData = new FormData();

        formData.append('title', pressroom.title);
        formData.append(
          'postingDate',
          moment(pressroom.postingDate).utc().format('YYYY-MM-DD')
        );
        formData.append('url', pressroom.url || '');
        formData.append('type', pressroom.type);
        formData.append('isActive', pressroom.isActive);

        if (pressroom.files_document?.[0] instanceof File) {
          formData.append('pressroom', pressroom.files_document[0]);
        } 

        const { data } = await axios.put(
          `/api/pressroom/gestao/${pressroom.id}`,
          formData
        );

        return data;
      } catch (error) {
        return handleErrors(error);
      }
    },


    delete: async (id) => {
      try {
        const axios = axiosDefault();

        const { data } = await axios.delete(`/api/pressroom/gestao/${id}`);
        return data;
      } catch (error) {
        return handleErrors(error);
      }
    },
  },

  user: {
    get: async (id) => {
      try {
        const axios = axiosDefault();
        const { data } = await axios.get(`/api/pressroom/${id}`);

        return data;
      } catch (error) {
        return handleErrors(error);
      }
    },

    getList: async ({ limit = '', search = '', offset = '', random = '' }) => {
      try {
        const axios = axiosDefault();
        const { data } = await axios.get(
          `/api/pressroom?limit=${limit}&title=${search}&offset=${offset}&random=${random}`,
        );

        return data;
      } catch (error) {
        return handleErrors(error);
      }
    },
  },
};

export default pressRoomService;
